// extracted by mini-css-extract-plugin
module.exports = {"tablist":"Tabs_tablist__24ZUP","tab":"Tabs_tab___S_Gb","count":"Tabs_count__bkqyG","segmented":"Tabs_segmented__22dUS","segment":"Tabs_segment__3KuPE"};